import React, { Component } from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'
import Home from './pages/Home'
import Directory from './pages/Directory'
import Herstory from './pages/Herstory'
import EventsCalendar from './pages/EventsCalendar'
import Living from './pages/Living'
import Login from './admin/Login'
import Admin from './admin/Admin'

import { auth, kesAdmin, provider } from '../firebase.js'

function AdminRoute ({...rest}) {
	return (
		rest.user !== null ?
			<Admin {...rest} />
			:
			<Redirect to={{pathname: '/login'}} />
	)
}

class Main extends Component {
	constructor(){
		super()
		this.state = {
			user: null,
			loading: true
		}
	}

  componentDidMount () {
    this.removeListener = auth.onAuthStateChanged((user) => {
      if (user && (user.uid === kesAdmin)) {
				// console.log("user is admin")
				this.setState({
					user: user,
					loading: false,
				})
				// console.log("redirecting to /admin...")
			} else {
				// console.log("user is null/first time init")
				this.setState({
					user: null,
					loading: false
				})
			}
    })
  }
  componentWillUnmount () {
    this.removeListener()
  }

	login = () => {
		auth.signInWithPopup(provider)
		.then((result) => {
			if (result.user.uid === kesAdmin) {
				// console.log("successful login: user is admin")
				this.setState({
					user: result.user
				})
			} else {
				// console.log("failed login: you are not an admin")
			}
		})
	}

	logout = () => {
		auth.signOut()
    .then(() => {
      this.setState({
        user: null
      })
    })
	}

  render() {
    return this.state.loading === true ? <div className="pa2"> </div> : (
      <div>
				<Switch>
					<Route exact path="/" component={Home}/>
					<Route path="/directory" component={Directory}/>
					<Route path="/calendar" component={EventsCalendar}/>
					<Route path="/living" component={Living}/>
					<Route path="/history" component={Herstory}/>
					<Route path="/login" render={() => ( <Login login={this.login} logout={this.logout} user={this.state.user}/> )} />
					<AdminRoute path='/admin' user={this.state.user} logout={this.logout} />
				</Switch>
      </div>
    )
  }
}

export default Main



// WEBPACK FOOTER //
// ./src/components/Main.js